import React, { useRef, useEffect, useState } from "react";
import ModalDropdown from "../../component/ModalDropdown";
import CloseIcon from "@mui/icons-material/Close";
import InputBox from "../../component/InputBox";
import SelectBox from "../../component/SelectBox";
import Button from "../../component/Button";
import { FormProvider, useForm, Controller, useFieldArray } from "react-hook-form";
import classes from "./style.module.scss";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import GetUserPermission from "../../component/GetUserPermission";
import { useNavigate } from "react-router-dom";

const AddMembership = (props) => {
  const {
    isOpen = false,
    closePopUp,
    handleSuccessModal,
    isEdit,
    setIsEdit,
    getLoyaltyProgramList,
    id,
  } = props;
  const selectBoxRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [memberId, setMemberId] = useState(id)
  const addPermission = GetUserPermission({ key: 'add', microAppPath: 'rewards' });
  const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'rewards' });

  const statusList = [
    { label: "Active", value: true },
    { label: "InActive", value: false },
  ];

  const formMethods = useForm({
    mode: "onSubmit",
    defaultValues: {
      rewards: [{ text: "" }]
    }
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    trigger,
    setValue,
    control,
    watch,
  } = formMethods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "rewards",
  });

  const rewards = watch("rewards");

  useEffect(() => {
    if (id) {
      getDetails(id);
    } 
  }, [id]);

  // useEffect(() => {
  //   if (isEdit) {
  //     if (!editPermission) {
  //       closePopUp()
  //       redirectBack()
  //     }
  //   } else {
  //     if (!addPermission) {
  //       closePopUp()
  //       redirectBack()
  //     }
  //   }
  // }, [isEdit])

  const redirectBack = () => {
    navigate(`/admin/loyalty-program`);
  };

  const getDetails = async (id) => {
    let url = `${Exported.Endpoints.getLoyaltyProgram}/${id || memberId}`;

    await request({
      url: url,
    })
      .then((res) => {
        if (res?.data?.status) {
          let detailInfo = res?.data?.data;
          setValue("name", detailInfo?.name);
          setValue("rewards", detailInfo?.rewardDetails === null ? [""] : detailInfo?.rewardDetails );
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
  };

  const onSubmit = async (data) => {
    console.log("Form Data: ", data);
    trigger();
    dispatch(saveLoadingState(true));

    let requestData = {
      name: data?.name,
      status : true,
      maxPoints: 0,
      rewardDetails: data?.rewards,
    };

    await request({
      url: `${Exported.Endpoints.getLoyaltyProgram}/${id || memberId}`,
      method: Exported.APIMethods.PUT,
      // url: isEdit
      //   ? `${Exported.Endpoints.getLoyaltyProgram}/${id}`
      //   : `${Exported.Endpoints.getLoyaltyProgram}`,
      // method: isEdit ? Exported.APIMethods.PUT : Exported.APIMethods.POST,
      data: requestData,
    })
      .then((res) => {
        if (res?.data?.status) {
          dispatch(saveLoadingState(false));
          handleSuccessModal();
          setMemberId(null)
          getLoyaltyProgramList();
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
        setMemberId(null)
      });
    dispatch(saveLoadingState(false));
  };

  const addReward = (e) => {
    e.preventDefault()
    append("");
  };

  return (
    <>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        selectBoxRef={selectBoxRef}
      >
        <div className={`${classes.addMembershipWrapper}`}>
          <div
            className={`${classes.modalHeader} flex items-center justify-between`}
          >
            <div className={`${classes.modalTitle}`}>
              {/* {isEdit ? "Edit" : "Add"} Membership */}
              Edit Membership
            </div>
            <div className={`${classes.modalCloser}`}>
              <CloseIcon onClick={() => closePopUp()} />
            </div>
          </div>
          <div className={`${classes.reasonFormContainer}`}>
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Membership name"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"name"}
                    {...register("name", {
                      required: true,
                    })}
                    placeholder={"Membership name"}
                    error={errors.name}
                    messages={{
                      required: "Membership name is required",
                    }}
                    isEdit={true}
                    disabled = {true}
                  />
                </div>
                {/* <div className={`${classes.formField} !mb-5`}>
                  <InputBox
                    label={"Points"}
                    className={`w-[100%] ${classes.notesInput}`}
                    name={"minPoints"}
                    {...register("minPoints", {
                      required: true,
                    })}
                    placeholder={"Points"}
                    error={errors.minPoints}
                    messages={{
                      required: "Points is required",
                    }}
                    isEdit={isEdit}
                  />
                </div>
                <div className={`${classes.formField} !mb-5`}>
                  <Controller
                    name="status"
                    control={formMethods?.control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectBox
                        label="Status"
                        placeholder="Status"
                        list={statusList}
                        isEdit={isEdit}
                        {...field}
                        error={errors.status}
                        messages={{
                          required: "Status is required",
                        }}
                      />
                    )}
                  />
                </div> */}
                {fields.map((item, index) => (
                  <div key={item.id} className="flex items-center mb-4">
                    <div className="relative w-full">
                      <InputBox
                      {...register(`rewards.${index}`, {
                        required: true,
                      })}
                        label={`Reward details`}
                        className={`w-[100%] ${classes.notesInput}`}
                        placeholder={`Enter reward detail`}
                        error={errors?.rewards?.[index]} 
                        messages={{
                          required : `Reward details ${index + 1} is required`
                        }} 
                      />
                     <div
                        onClick={() => remove(index)}
                        className="absolute right-4 top-4 cursor-pointer text-white bg-[#858485] rounded-full flex items-center justify-center"
                      >
                        <CloseIcon fontSize="small" />
                      </div>


                    </div>
                  </div>
                ))}
                <div className="flex justify-start">
                  <Button text={"+ Add another reward"} className={`w-[100%]`} smallBtn style={{ backgroundColor: "white", border: "0px", color: "#1F2155", fontWeight: "600", }} onClick={addReward} />
                </div>
                <div className="flex justify-end">
                  <Button text={"Save"} className={`w-[100%] my-4`} smallBtn />
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </ModalDropdown>
    </>
  );
};

export default AddMembership;
